import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { DateRange, KngFilterPanelComponent, Option } from 'kinetic-angular';
import { DateFilterType } from '../shared/shared-enums';

@Injectable({
	providedIn: 'root'
})
export class DateConverterService 
{
	currentDate = new Date();
	constructor(public datepipe: DatePipe) { }

	getUnixTimeStamp(date: Date) 
	{
		return date.getTime();
	}

	getUnitTimeInAmPm(value: string) 
	{
		const date = new Date(value);
		return date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }).toLowerCase();
	}
	getDateWithUnitTimeInAmPm(value: string) 
	{
		const date = new Date(value);
		return  this.formatUnixDate(value)+'; '+ date.toLocaleString('UTC', { hour: 'numeric', minute: 'numeric', hour12: true });
	}
	getFromDate(date: Date, days: number) 
	{
		return date.setDate(date.getDate() - days);
	}

	getNextToDate(date: Date, days: number)
	{
		return date.setDate(date.getDate() + days);
	}
	tranformDate(date: string, format: string) 
	{
		return this.datepipe.transform(new Date(date), format);
	}

	formatUnixDate(value: string | number) 
	{
		const date = new Date(value);
		const month = date.getMonth() + 1;
		const dateRes = date.getDate();
		return (month < 10 ? ('0' + month) : month) + '/' + (dateRes < 10 ? ('0' + dateRes) : dateRes) + '/' + date.getFullYear();
	}
	calculateDate(label: string, currentDate: Date) 
	{
		const commonDate = new Date(currentDate);
		let fromDate: number = 0;
		switch (label) 
		{
		case DateRange.lastDay: {
			fromDate = this.getFromDate(commonDate, 1);
			break;
		}
		case DateRange.lastSevenDays: {
			fromDate = this.getFromDate(commonDate, 7);
			break;
		}
		case DateRange.lastThirtyDays: {
			fromDate = this.getFromDate(commonDate, 30);
			break;
		}
		case DateRange.lastSixtyDays: {
			fromDate = this.getFromDate(commonDate, 60);
			break;
		}
		case DateRange.lastSixtyDaysWithoutDefault: {
			fromDate = this.getFromDate(commonDate, 60);
			break;
		}
		default: {
			fromDate = this.calculateDateOnQuaterly(commonDate, label);
			break;
		}
		}
		return fromDate;
	}
	calculateDateOnQuaterly(commonDate: Date, label: string) 
	{

		let fromDate: number = 0;
		switch (label) 
		{
		case DateRange.lastQuarter: {
			fromDate = this.getFromDate(commonDate, 90);
			break;
		}
		case DateRange.lastYear: {
			fromDate = this.getFromDate(commonDate, 365);
			break;
		}
		case DateRange.lastYearDefault: {
			fromDate = this.getFromDate(commonDate, 365);
			break;
		}
		case DateRange.last2YearsDefault: {
			fromDate = this.getFromDate(commonDate, (365*2));
			break;
		}
		}
		return fromDate;
	}

	calculateNextDates(label: string, currentDate: Date)
	{
		const commonDate = new Date(currentDate);
		let toDate: number = 0;
		switch(label)
		{
		case DateRange.nextSevenDays: {
			toDate = this.getNextToDate(commonDate, 7);
			break;
		}
		case DateRange.nextThirtyDays: {
			toDate = this.getNextToDate(commonDate, 30);
			break;
		}
		case DateRange.nextSixtyDays: {
			toDate = this.getNextToDate(commonDate, 60);
			break;
		}
		case DateRange.nextYear: {
			toDate = this.getNextToDate(commonDate, 365);
			break;
		}
		case DateRange.nextQuarter: {
			toDate = this.getNextToDate(commonDate, 90);
			break;
		}
		}
		return toDate;
	}
	dateCalculation(options: Option[], label: string, dateFilterType: string = DateFilterType.last) 
	{
		const fromToDate : number[] = [];
		if(label === DateRange.custom)
		{
			options.forEach((opt) =>
			{
				if (opt.label === label)
				{
					const dateRange = opt.value.split('@');
					fromToDate[0] = this.getUnixTimeStamp(new Date(dateRange[0]));
					fromToDate[1] = this.getUnixTimeStamp(new Date(dateRange[1]));
				}
			});
		}
		else 
		{	
			switch(dateFilterType)
			{
			case DateFilterType.last: {
				fromToDate[0] = this.calculateDate(label, this.currentDate);
				fromToDate[1] = this.getUnixTimeStamp(this.currentDate);
				break;
			}
			case DateFilterType.next: {
				fromToDate[0] = this.getUnixTimeStamp(this.currentDate);
				fromToDate[1] = this.calculateNextDates(label, this.currentDate);
				break;
			}
			}
		}
		return fromToDate;
	}

	showHideFromToDate(filterComponent: KngFilterPanelComponent | undefined)
	{
		if (filterComponent)
		{
			filterComponent.showToFromInput = false;
		}
	}

}
